"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emotionTheming = require("emotion-theming");

var s = _interopRequireWildcard(require("./MultiProgressCircle.style"));

var MultiProgressCircle =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(MultiProgressCircle, _PureComponent);

  function MultiProgressCircle() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MultiProgressCircle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MultiProgressCircle)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderSectionArc", function (center, radius) {
      return function (sectionInfo, index, sections) {
        var strokeWidth = _this.props.strokeWidth;
        var numSections = sections.length;
        var circumference = 2 * Math.PI * radius;
        var sectionArcLength = circumference / numSections;
        var color = sectionInfo.color,
            progress = sectionInfo.progress;

        if (!progress) {
          return null;
        }

        var filledSectionLength = numSections > 1 ? sectionArcLength - 10 : sectionArcLength;
        var filledSectionCompletedLength = filledSectionLength * progress;
        var remainingSectionLength = circumference - filledSectionCompletedLength;
        var sectionDashArray = "".concat(filledSectionCompletedLength, " ").concat(remainingSectionLength);
        return _react.default.createElement("circle", {
          key: index + '-arc',
          cx: center,
          cy: center,
          r: radius,
          strokeWidth: strokeWidth,
          strokeDashoffset: -index * sectionArcLength,
          strokeDasharray: sectionDashArray,
          style: {
            stroke: color
          }
        });
      };
    });
    return _this;
  }

  (0, _createClass2.default)(MultiProgressCircle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          style = _this$props.style,
          strokeWidth = _this$props.strokeWidth,
          sections = _this$props.sections,
          className = _this$props.className,
          theme = _this$props.theme,
          isDark = _this$props.isDark;
      var viewBoxSize = 100 + strokeWidth;
      var viewBox = "0 0 ".concat(viewBoxSize, " ").concat(viewBoxSize);
      var center = viewBoxSize / 2;
      var radius = 50;
      var circumference = 2 * Math.PI * radius;
      var numSections = sections.length;
      var sectionArcLength = circumference / numSections;
      var backgroundCircleStrokeDasharray = numSections > 1 ? "".concat(sectionArcLength - 10, " 10") : sectionArcLength.toString();
      return _react.default.createElement("svg", {
        className: (0, _classnames.default)(s.root, className),
        style: style,
        width: size,
        height: size,
        viewBox: viewBox
      }, _react.default.createElement("circle", {
        className: s.backgroundCircle(theme, isDark),
        cx: center,
        cy: center,
        r: radius,
        strokeWidth: strokeWidth,
        strokeDasharray: backgroundCircleStrokeDasharray
      }), sections.map(this.renderSectionArc(center, radius)));
    }
  }]);
  return MultiProgressCircle;
}(_react.PureComponent);

MultiProgressCircle.propTypes = {
  size: _propTypes.default.number.isRequired,
  sections: _propTypes.default.arrayOf(_propTypes.default.shape({
    color: _propTypes.default.string,
    progress: _propTypes.default.number
  })).isRequired,
  strokeWidth: _propTypes.default.number,
  style: _propTypes.default.object,
  className: _propTypes.default.string,
  isDark: _propTypes.default.bool
};
MultiProgressCircle.defaultProps = {
  strokeWidth: 4,
  style: {},
  className: '',
  isDark: false
};

var _default = (0, _emotionTheming.withTheme)(MultiProgressCircle);

exports.default = _default;